<script>
export default {
  name: "IconImage"
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="currentColor" fill-rule="nonzero">
      <path
        d="M13,0 C14.6568542,-3.04359188e-16 16,1.34314575 16,3 L16,13 C16,14.6568542 14.6568542,16 13,16 L3,16 C1.34314575,16 2.02906125e-16,14.6568542 0,13 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 L13,0 Z M11.2592,8.272 L7.7656,11.7656 C7.45320012,12.0779056 6.94679988,12.0779056 6.6344,11.7656 L6.6344,11.7656 L4.7408,9.872 L1.6,12.3848 L1.6,13.4 C1.6,13.9522847 2.04771525,14.4 2.6,14.4 L2.6,14.4 L13.4,14.4 C13.9522847,14.4 14.4,13.9522847 14.4,13.4 L14.4,13.4 L14.4,10.7848 L11.2592,8.272 Z M13.4,1.6 L2.6,1.6 C2.04771525,1.6 1.6,2.04771525 1.6,2.6 L1.6,2.6 L1.6,10.3352 L4.3,8.1752 C4.61838767,7.92050462 5.07738405,7.94600442 5.3656,8.2344 L5.3656,8.2344 L7.2,10.0688 L10.6344,6.6344 C10.922616,6.34600442 11.3816123,6.32050462 11.7,6.5752 L11.7,6.5752 L14.4,8.7352 L14.4,2.6 C14.4,2.04771525 13.9522847,1.6 13.4,1.6 L13.4,1.6 Z"
      />
      <circle cx="4.8" cy="4.8" r="1.6" />
    </g>
  </svg>
</template>
